import { HeadersWithoutApiKeyWorkaround } from './constants';
import createTag from '../graphql/mutations/createTag';
import queryProfileTags from '~/graphql/queries/queryProfileTags';
import updateTag from '~/graphql/mutations/updateTag';
import deleteTag from '~/graphql/mutations/deleteTag';

export const state = () => ({
    tags: [],
    tagIDsForFilter: [],
});

export const actions = {
    async createTag(context, payload) {
        const tag = (await this.app.apolloProvider.defaultClient.mutate({
            mutation: createTag.createTagMutation,
            context: HeadersWithoutApiKeyWorkaround,
            variables: payload,
        }))?.data?.createTag;

        if (!tag) {
            return new Error('Failed to create tag');
        }

        await context.commit('addTag', tag);
        return tag;
    },

    async getProfileTags(context, { profileID }) {
        const tags = (await this.app.apolloProvider.defaultClient.query({
            query: queryProfileTags.profileTags,
            variables: { profileID: profileID },
            context: HeadersWithoutApiKeyWorkaround,
        })).data?.profileTags;

        await context.commit('setTags', tags);
    },

    async updateTag(context, { id, name, color }) {
        await this.app.apolloProvider.defaultClient.query({
            query: updateTag.updateTagMutation,
            variables: {
                id: id,
                name: name,
                color: color,
            },
            context: HeadersWithoutApiKeyWorkaround,
        });

        await context.commit('updateTag', { id, name, color });
        await context.dispatch('campaign/fetchMyCampaigns', null, { root: true });
    },

    async deleteTag(context, { id }) {
        await this.app.apolloProvider.defaultClient.query({
            query: deleteTag.deleteTagMutation,
            variables: {
                tagID: id,
            },
            context: HeadersWithoutApiKeyWorkaround,
        });

        await context.commit('removeTag', { id });
        await context.dispatch('campaign/fetchMyCampaigns', null, { root: true });
    },

    async toggleTagIdsForFilter(context, tagID) {
        await context.commit('setTagIdsForFilter', tagID);
    },
};

export const mutations = {
    setTagIdsForFilter(state, tagID) {
        let tags = [ ...state.tagIDsForFilter ];
        if (tags.includes(tagID)) {
            tags = tags.filter(tag => tag !== tagID)
        } else {
            tags.push(tagID);
        }

        state.tagIDsForFilter = tags;
    },

    addTag(state, tag) {
        if(state.tags.includes(tag)) { return }
        state.tags.push(tag);
    },
    setTags(state, tags) {
        state.tags = tags
    },
    updateTag(state, { id, name, color }) {
        const tag = state.tags.find(tag => tag.id === id);
        tag.name = name;
        tag.color = color;
    },
    removeTag(state, { id }) {
        state.tags = state.tags.filter(tag => tag.id !== id);
    },
};

export const getters = {
    tags(state) {
        return state.tags;
    },

    tagIDsForFilter(state) {
        return state.tagIDsForFilter;
    },
};
